import type { Channel } from 'stream-chat';
import { MdDoneAll } from 'react-icons/md';
import { MessageDeliveryStatus } from 'stream-chat-react';
import { type MessageForPreview } from '../types';
import { ChannelPreviewActionButtons } from './ChannelPreviewActionButtons';
import { formatMessageTime } from '../utils';

type PreviewTitleProps = {
  channel: Channel;
  displayTitle?: string;
  message?: MessageForPreview | null;
  messageDeliveryStatus?: MessageDeliveryStatus;
};

export const PreviewTitle = ({ channel, displayTitle, message, messageDeliveryStatus }: PreviewTitleProps) => {
  const formattedTime = formatMessageTime(message);

  return (
    <div className="flex items-center w-full min-w-0">
      <span className="truncate text-base-5 text-m-m mr-1">{displayTitle}</span>
      <ChannelPreviewActionButtons channel={channel} />
      <div className="ml-auto flex items-center shrink-0 pl-2">
        {messageDeliveryStatus && (
          <span className="shrink-0 flex items-center pr-[2px]">
            <MdDoneAll
              size={16}
              className={messageDeliveryStatus === MessageDeliveryStatus.READ ? 'text-green' : 'text-base-40'}
            />
          </span>
        )}
        {formattedTime && <span className="text-s-m text-base-30">{formattedTime}</span>}
      </div>
    </div>
  );
};
